var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentMethods(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 13,
    height: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 17.5H1.25C0.918479 17.5 0.600537 17.3683 0.366116 17.1339C0.131696 16.8995 0 16.5815 0 16.25L0 6.25H20V16.25C20 16.9412 19.4412 17.5 18.75 17.5ZM10.9462 9.18875C10.4825 8.91625 9.95 8.75 9.375 8.75C7.64875 8.75 6.25 10.1487 6.25 11.875C6.25 13.6012 7.64875 15 9.375 15C9.95 15 10.4825 14.8337 10.9462 14.5612C10.3625 13.8187 10 12.8925 10 11.875C10 10.8575 10.3625 9.93125 10.9462 9.18875ZM14.375 8.75C12.6487 8.75 11.25 10.1487 11.25 11.875C11.25 13.6012 12.6487 15 14.375 15C16.1012 15 17.5 13.6012 17.5 11.875C17.5 10.1487 16.1012 8.75 14.375 8.75ZM0 3.75C0 3.41848 0.131696 3.10054 0.366116 2.86612C0.600537 2.6317 0.918479 2.5 1.25 2.5H18.75C19.4412 2.5 20 3.05875 20 3.75V5H0V3.75Z",
    fill: "#002E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethods);
export default __webpack_public_path__ + "static/media/payment-methods.0bc2cc7db3cd8514a96249336aaca771.svg";
export { ForwardRef as ReactComponent };